module.exports = __webpack_public_path__ + "static/media/infoJumbo2.7ccd63ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fanuc/images/infoJumbo2.jpg
// module id = 587
// module chunks = 0